import { Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
import { UserService } from 'src/app/services/user.service';
import { NeoIntermediarioFinancieroService } from '../../Service/neoIntermediarioFinanciero.service';
import { NeoOperadorDatosService } from 'src/app/comun/services/neoOperadorDatos.service';
import { parametrizacionBuroDTO } from '../../Model/parametrizacionBuroDTO';

declare var $: any;

@Component({
    selector: 'app-administrar-buros-credito',
    templateUrl: './administrar-buros-credito.component.html',
    styleUrls: ['./administrar-buros-credito.component.scss'],
    standalone: false
})

export class AdministrarBurosCreditoComponent implements OnInit {

  buroCreditoForm: UntypedFormGroup;
  nit: any;
  public user;
  // listas
  listaOperadorDatos: any[] = [];
  buros: any [] = [];
  constructor(private _formBuilder: UntypedFormBuilder,
    private _sweetAlert: SweetAlertService,
    private _user: UserService,
    private _intermediarioService: NeoIntermediarioFinancieroService,
    private _operadorDatosService: NeoOperadorDatosService,
  ) {
    this.user = this._user.getUser();
    this.nit = +this.user.nit;
  }

  ngOnInit(): void {
    this.obtenerOperadores();
    this.buroCreditoForm = this._formBuilder.group({
      configuraciones: new UntypedFormArray([])
    });    
  }
  // form array

  agregarConfiguracion(): void {
    this.listaOperadorDatos.forEach((opcion) => {
      const datoPrecargado = this.buros.find(
        (dato) => dato.idOperDatos === opcion.idOperDatos
      );
      const configuracionGroup = this._formBuilder.group({
        habilitado: new UntypedFormControl(datoPrecargado ? datoPrecargado.habilitado : false),
        nameConsulta: new UntypedFormControl(opcion.nombre || ''),
        idOperDatos: new UntypedFormControl(datoPrecargado ? datoPrecargado.idOperDatos : opcion.idOperDatos),
        puntMinScorePnf: new UntypedFormControl(datoPrecargado ? datoPrecargado.puntMinScorePnf : null),
        puntMinScorePn: new UntypedFormControl(datoPrecargado ? datoPrecargado.puntMinScorePn : null),
        puntMinScorePj: new UntypedFormControl(datoPrecargado ? datoPrecargado.puntMinScorePj : null),
        nit: new UntypedFormControl(this.nit, Validators.required)
      });
      this.configuraciones.push(configuracionGroup);
    });
  }

  get configuraciones(): UntypedFormArray {
    return this.buroCreditoForm.get('configuraciones') as UntypedFormArray;
  }

  obtenerOperadores() {
    this._operadorDatosService.getAll().subscribe((response: any) => {
      if (response) {
        this.listaOperadorDatos = response;
        this.obtenerParametrizacion();
      } else {
        this._sweetAlert.errorModal("Error!", true, 'Error en el servicio obtenerOperadores.');
      }
    }, (error: any) => {
      this._sweetAlert.errorModal("Error!", true, 'Error en el servicio');
    });
  }

  obtenerParametrizacion() {
    this._intermediarioService.getParametrizacionBuro(this.user.nit).subscribe(
      (response: any) => {
        if (response && response.exitoso && response.buros) {
          this.buros = response.buros;
          this.agregarConfiguracion();          
        } 
      },
      (error: any) => {
        this._sweetAlert.errorModal("Error!", true, 'Error en el servicio');
      }
    );
  }

  guardar() {
    let valid = true;
    let aux = [...this.configuraciones.controls];
    aux.forEach((fila, index) => {
      const puntMinScorePnf = fila.get('puntMinScorePnf')?.value;
      const puntMinScorePn = fila.get('puntMinScorePn')?.value;
      const puntMinScorePj = fila.get('puntMinScorePj')?.value;
      if (!puntMinScorePnf && !puntMinScorePn && !puntMinScorePj) {
        aux.splice(index); // Eliminar la fila vacía
      }
      if (puntMinScorePnf && (!puntMinScorePn && !puntMinScorePj) ||
        puntMinScorePn && (!puntMinScorePnf && !puntMinScorePj) ||
        puntMinScorePj && (!puntMinScorePn && !puntMinScorePnf)) {
        valid = false;
      }
    });
    if (valid) {
      const body =
        aux.map(item => {
          return {
            idIntermediarioFinanciero: item.get('nit')?.value,
            puntMinScorePnf: item.get('puntMinScorePnf')?.value,
            puntMinScorePn: item.get('puntMinScorePn')?.value,
            puntMinScorePj: item.get('puntMinScorePj')?.value,
            idOperDatos: item.get('idOperDatos')?.value,
            habilitado: item.get('habilitado')?.value
          };
        });
      this._intermediarioService.saveParametrizacionBuro(body).subscribe((response: any) => {
        if (response.exitoso) {
          this._sweetAlert.successModal('Parametrización guardada exitosamente!');
        } else {
          this._sweetAlert.errorModal("Error!", true, 'Error al guardar la parametrización!');
        }
      });
    }
    else {
      this._sweetAlert.errorModal("Error!", true, 'Todos los campos de la fila deben estar completos. Valida los campos vacíos antes de guardar la parametrización.');
    }
  }
}